import React from 'react';
import {
	TypingIndicatorWrapper,
	TypingIndicatorAvatarSlot,
	WaveIndicatorText,
} from './AIChat.Styled';

// One steady word while nothing more specific is known, like other assistants; the steps say the rest.
const DEFAULT_TEXT = 'Thinking…';

export type AIChatWaveIndicatorProps = {
	assistantAvatarSrc?: string;
	/** What to shimmer; "Thinking…" when omitted. */
	text?: string;
};

export function AIChatWaveIndicator(
	{ assistantAvatarSrc, text: propsText }: AIChatWaveIndicatorProps
): React.ReactElement {
	const text = propsText || DEFAULT_TEXT;
	const showAvatar = Boolean(assistantAvatarSrc);
	return (
		<TypingIndicatorWrapper role="status" aria-label="Assistant is thinking">
			<TypingIndicatorAvatarSlot
				$visible={showAvatar}
				style={showAvatar ? { backgroundImage: `url(${assistantAvatarSrc})` } : undefined}
			/>
			<WaveIndicatorText>{text}</WaveIndicatorText>
		</TypingIndicatorWrapper>
	);
}
